export default {
  default: [
    {
      path: "partner/:partnerId/adviseur/aanmaken",
      name: "advisors.create",
      component: () => import("./views/AdvisorFormView.vue")
    },
    {
      path: "adviseur/:id",
      name: "advisors.view",
      component: () => import("./views/AdvisorDetailsView.vue"),
      children: [
        {
          path: "spaarders",
          name: "advisors.view.funders",
          component: () => import("./views/advisorDetails/FundersView.vue")
        },
        {
          path: "details",
          name: "advisors.view.details",
          component: () => import("./views/advisorDetails/DetailsView.vue")
        }
      ]
    },
    {
      path: "adviseur/:id/wijzigen",
      name: "advisors.edit",
      component: () => import("./views/AdvisorFormView.vue")
    }
  ]
};
